<template>
  <b-modal
    id="modal-delete-tunj"
    size="md"
    centered
    title="Perhatian"
    header-bg-variant="danger"
    header-text-variant="light"
  >
    <p>Apakah anda yakin akan menghapus data ini ?</p>

    <template #modal-footer>
      <b-button
        variant="primary"
        @click="hapus()"
      >
        {{ $store.state.form.ya }}
      </b-button>
      <b-button
        variant="secondary"
        @click="$bvModal.hide('modal-delete-tunj')"
      >
        {{ $store.state.form.tidak }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "modalDelete",
  props: ["dataTunjangan"],
  data() {
    return {
      busy:false,
      button:"Hapus"
    };
  },
  methods: {
    hapus() {
      let vm = this;
      vm.busy = true
      vm.button = "Mohon Tunggu"
      vm.dataTunjangan.id = vm.dataTunjangan.poolTunjanganId
      vm.$axios
        .post("poolTunjangan/delete", vm.dataTunjangan)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MENGHAPUS DATA TUNJANGAN",
              showing: true,
            });
            vm.$bvModal.hide("modal-delete-tunj");
          } else {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          err
          vm.button = "Hapus";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
